import {notAuthorizedMessage} from './not-authorized.js';

export default function DashBoardService($wamp, $q) {

  let dash = {}, promises = [];

  // A part the backend won't give this login (no trading access, say) stays empty instead of failing
  // the load: every later load waits on this one's promises too.
  function unlessRefused(err) {
    if (!notAuthorizedMessage(err)) {
      throw err;
    }
  }

  function load() {
    const a = $wamp.call('org.eggs.today_bot_counts', []).then(
        function (res) {
          dash.counts = res;
        }, unlessRefused);
    promises.push(a);

    const b = $wamp.call('org.eggs.outstanding_fees', []).then(
        function (res) {

          dash.fees = res;
        }, unlessRefused);
    promises.push(b);

    const c = $wamp.call('org.eggs.get_user_info', []).then(
        function (res) {
          dash.user = res;
        }, unlessRefused);
    promises.push(c);

    const d = $wamp.call('org.eggs.account_balances', []).then(
        function (res) {
          dash.balances = res;
        }, unlessRefused);
    promises.push(d);

    const e = $wamp.call('org.eggs.seller_account_needs', []).then(
        function (res) {
          dash.needs = res;
        }, unlessRefused);
    promises.push(e);

    return $q.all(promises);
  }

  return {
    get: function () {
      return dash;
    },
    load: load

  };
}
